export enum FonteDadosComunicacaoSituacao {
  SUCESSO= 'SUCESSO',
  FALHA = 'FALHA',
}
